export { default } from './Tooltip';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Tooltip/index.jsx